<template>
    <div class="file-manage-container">
        <div class="card-container" v-if="Status.LoadingCompleted">
            <div class="search-box">
                <el-input 
                    v-model="CurSearch" 
                    placeholder="请输入任务标题" 
                    clearable
                    @keyup.enter.native="OnSearch(2)"
                    style="width: 350px;">
                    <i slot="prefix" class="el-icon-search"></i>
                </el-input>
                <el-button type="primary" icon="el-icon-search" @click="OnSearch(2)">查询</el-button>
                <el-button icon="el-icon-refresh" @click="OnSearch(1)">重置</el-button>
            </div>

            <div class="data-table">
                <el-table 
                    :data="List" 
                    border 
                    stripe
                    style="width: 100%"
                    :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}"
                    empty-text="暂无数据"
                    ref="table"
                    height="calc(100vh - 350px)">
                    
                    <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                    <el-table-column prop="L_Title" label="任务标题" min-width="150" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="L_AddTime" label="创建时间" width="160" align="center">
                        <template slot-scope="{ row }">
                            {{ GetDateTimeString(row.L_AddTime) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="L_Field4" label="任务状态" width="200" align="center">
                        <template slot-scope="{ row }">
                            <el-tooltip v-if="isRunning(row.L_Field4)" :content="row.L_Field4" placement="top">
                                <el-progress :percentage="getPercent(row.L_Field4)" :text-inside="true" :stroke-width="16" class="status-progress"></el-progress>
                            </el-tooltip>
                            <el-tag v-else-if="row.L_Field4 === '生成完毕'" type="success" size="small">生成完毕</el-tag>
                            <el-tag v-else-if="isWaiting(row.L_Field4)" type="info" size="small">{{ row.L_Field4 || '等待处理' }}</el-tag>
                            <el-tag v-else type="danger" size="small">失败</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="报错信息" min-width="150" align="center">
                        <template slot-scope="{ row }">
                            <el-button v-if="getErrorInfo(row)" type="text" size="small" class="error-link" @click="showError(row)">
                                <i class="el-icon-warning"></i> 查看详情
                            </el-button>
                            <span v-else class="text-muted">-</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="L_Field3" label="解压密码" width="100" align="center"></el-table-column>

                    <el-table-column label="操作" width="200" align="center" fixed="right">
                        <template slot-scope="{ row }">
                            <el-button 
                                v-if="row.L_Field3 && row.L_Field1" 
                                type="text" 
                                size="small" 
                                @click="handleDownload(row)">
                                <i class="el-icon-download"></i> 下载
                            </el-button>
                            <el-button 
                                type="text" 
                                size="small" 
                                @click="handleDelete(row)">
                                <i class="el-icon-delete"></i> 删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="PageInfo.CurPage"
                    :page-sizes="[20, 50, 100, 200]"
                    :page-size="PageInfo.RecordCountOfPage"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="PageInfo.RecordCount">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { TYBM_Env } from '../../env.js';
    import { TYBM_Tools } from '../../tools.js';

    export default {
        name: 'FileManage',
        inject: ['Loading', 'LoadingCompleted'],
        data: function () {
            return {
                Status: {
                    LoadingCompleted: false
                },
                PageInfo: {
                    CurPage: 1,
                    PageCount: 1,
                    RecordCount: 1,
                    RecordCountOfPage: 20
                },
                CurSearch: '',
                List: [],
                pollTimer: null   // 进行中任务的轮询定时器
            }
        },
        methods: {
            OnSearch: function (type) {
                var that = this;
                if (type == 1) {
                    that.CurSearch = '';
                    that.LoadList();
                } else if (type == 2) {
                    that.LoadList();
                } else {
                    that.CurSearch = '';
                    that.LoadList();
                }
            },
            handleSizeChange(val) {
                this.PageInfo.RecordCountOfPage = val;
                this.LoadList(1, val);
            },
            handleCurrentChange(val) {
                this.LoadList(val, this.PageInfo.RecordCountOfPage);
            },
            LoadList: function (pageIdx, pageCount, silent) {
                var that = this;

                var api_name = '/Info/GetFileManageList';
                var url = TYBM_Env.GetApiUrl(api_name) + '?Search=' + encodeURIComponent(that.CurSearch || '');
                // silent=true 用于轮询刷新，不显示加载遮罩、不弹错误提示
                var options = silent ? { hide_tip: true } : { loading_msg: '正在加载数据' };
                TYBM_Tools.AxiosGetEx(that, api_name, TYBM_Tools.AppendPageInfo(url, pageIdx, pageCount), options)
                    .then(result => {
                        that.PageInfo = result.data.PageInfo;
                        that.List = result.data.List;
                        that.Status.LoadingCompleted = true;
                        that.checkPolling();
                    }).catch(() => { });
            },
            // ===== 任务状态解析 =====
            isRunning: function (status) {
                return !!status && status.indexOf('处理中') >= 0;
            },
            isWaiting: function (status) {
                return !status || status === '等待处理';
            },
            getPercent: function (status) {
                // 从 "处理中 35/120" 解析百分比
                var m = /(\d+)\s*\/\s*(\d+)/.exec(status || '');
                if (m) {
                    var done = parseInt(m[1], 10);
                    var total = parseInt(m[2], 10);
                    if (total > 0) {
                        return Math.min(100, Math.floor(done * 100 / total));
                    }
                }
                return 0;
            },
            getErrorInfo: function (row) {
                // 优先失败详情 L_Field5；否则若状态本身是错误消息（非进行中/完成/等待），也当作报错
                if (row.L_Field5) {
                    return row.L_Field5;
                }
                var s = row.L_Field4;
                if (s && s !== '生成完毕' && !this.isRunning(s) && !this.isWaiting(s)) {
                    return s;
                }
                return '';
            },
            showError: function (row) {
                var text = this.getErrorInfo(row);
                if (!text) {
                    return;
                }
                this.$alert(text.replace(/\n/g, '<br>'), '报错信息', {
                    dangerouslyUseHTMLString: true
                });
            },
            // ===== 进行中任务轮询 =====
            hasRunningTask: function () {
                var that = this;
                return that.List.some(function (row) {
                    return that.isRunning(row.L_Field4) || that.isWaiting(row.L_Field4);
                });
            },
            checkPolling: function () {
                if (this.hasRunningTask()) {
                    this.startPolling();
                } else {
                    this.stopPolling();
                }
            },
            startPolling: function () {
                var that = this;
                if (that.pollTimer) {
                    return;
                }
                that.pollTimer = setInterval(function () {
                    // 静默刷新当前页
                    that.LoadList(that.PageInfo.CurPage, that.PageInfo.RecordCountOfPage, true);
                }, 3000);
            },
            stopPolling: function () {
                if (this.pollTimer) {
                    clearInterval(this.pollTimer);
                    this.pollTimer = null;
                }
            },
            GetDateTimeString: function (date) {
                return TYBM_Tools.FormatDate('yyyy-MM-dd HH:mm:ss', new Date(date));
            },
            FormatFileSize: function (bytes) {
                if (!bytes || bytes === 0) return '-';
                const k = 1024;
                const sizes = ['B', 'KB', 'MB', 'GB'];
                const i = Math.floor(Math.log(bytes) / Math.log(k));
                return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i];
            },
            handleDownload: function (row) {
                if (!row.L_Field1) {
                    this.$message.warning('文件路径不存在');
                    return;
                }
                var downloadUrl = TYBM_Env.ServerHost + row.L_Field1;
                window.open(downloadUrl, '_blank');
                this.$message.success('已开始下载，请等待浏览器提示');
            },
            handleDelete: function (row) {
                var that = this;
                that.$confirm('确定要删除此任务记录吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var api_name = '/Info/DeleteFileManage';
                    var url = TYBM_Env.GetApiUrl(api_name);
                    TYBM_Tools.AxiosPostEx(that, api_name, url, { Model: JSON.stringify({ L_SN: row.L_SN }) }, { loading_msg: '正在删除...' })
                        .then(result => {
                            if (result.code === 'ok') {
                                that.$message.success('删除成功');
                                that.LoadList();
                            } else {
                                that.$message.error(result.errmsg || result.msg || '删除失败');
                            }
                        })
                        .catch(() => {
                            that.$message.error('删除失败');
                        });
                }).catch(() => { });
            }
        },
        created: function () {
            var that = this;
            that.PageInfo.CurPage = that.$route.query.Page || 1;
            that.LoadList();
        },
        beforeDestroy: function () {
            this.stopPolling();
        }
    }
</script>

<style scoped>
.file-manage-container {
    width: 100%;
}

.search-box {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    align-items: center;
}

.data-table {
    background: white;
    border-radius: 8px;
    overflow-x: auto;
}

.data-table >>> .el-table {
    font-size: 13px;
}

.data-table >>> .el-table th,
.data-table >>> .el-table td {
    padding: 0 !important;
    height: 40px !important;
}

.data-table >>> .el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

.data-table >>> .el-table__row {
    height: 40px !important;
}

.data-table >>> .el-table__row:hover {
    background-color: #f5f9ff;
}

.pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.data-table >>> .el-button--text {
    color: #409EFF;
    padding: 0;
}

.data-table >>> .el-button--text:hover {
    color: #66b1ff;
}

.data-table >>> .el-table .cell {
    padding: 0 8px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    line-height: 40px !important;
}

.data-table >>> .el-table th > .cell {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    height: 100% !important;
    line-height: normal !important;
}

.data-table >>> .el-button--text i {
    margin-right: 4px;
}

/* 任务状态进度条 */
.status-progress {
    width: 90%;
    margin: 0 auto;
}

.data-table >>> .status-progress .el-progress-bar {
    padding-right: 0;
    margin-right: 0;
}

/* 报错信息链接 */
.error-link {
    color: #f56c6c !important;
}

.error-link:hover {
    color: #f78989 !important;
}

.text-muted {
    color: #c0c4cc;
}

/* 固定列背景色 */
.data-table >>> .el-table__fixed-right {
    background-color: white !important;
}

.data-table >>> .el-table__fixed-right-patch {
    background-color: #f5f7fa !important;
}
</style>

